export default __webpack_public_path__ + "static/media/hp_slide6.629b4825.jpg";